import { render, staticRenderFns } from "./DonatePay.vue?vue&type=template&id=4cde226e&scoped=true&"
import script from "./DonatePay.vue?vue&type=script&lang=js&"
export * from "./DonatePay.vue?vue&type=script&lang=js&"
import style0 from "./DonatePay.vue?vue&type=style&index=0&id=4cde226e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cde226e",
  null
  
)

export default component.exports